/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WbsPlanningInputDto interface.
 */
export function instanceOfWbsPlanningInputDto(value) {
    return true;
}
export function WbsPlanningInputDtoFromJSON(json) {
    return WbsPlanningInputDtoFromJSONTyped(json, false);
}
export function WbsPlanningInputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'idWbs': json['idWbs'] == null ? undefined : json['idWbs'],
        'mese': json['mese'] == null ? undefined : json['mese'],
        'anno': json['anno'] == null ? undefined : json['anno'],
        'corrispettivo': json['corrispettivo'] == null ? undefined : json['corrispettivo'],
    };
}
export function WbsPlanningInputDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'idWbs': value['idWbs'],
        'mese': value['mese'],
        'anno': value['anno'],
        'corrispettivo': value['corrispettivo'],
    };
}
